// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.myQuery .el-form-item__content {\n\tline-height: 32px;\n\twidth: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
